// main.jsx: Preact entrypoint. M1-2 ships an empty app shell.
// M1-5 (Lua runtime init) and beyond layer onto this.
//
// Block first render on waitForFont() so the UI never paints the system
// sans first and re-flows to Nunito mid-animation. 3s cap inside the loader
// keeps it bounded on slow networks; a missing asset (404) resolves
// immediately to false and the body's font-family fallback takes over
// (AC #3, no throw, app renders).

// Design tokens must enter the bundle before any component sheet so
// every var() below resolves against :root. Vite orders the emitted
// CSS by module-graph position, and main.jsx is the graph root.
import './styles/tokens.css';
// Restyle step 1 faces (Tiny5 + Silkscreen, self-hosted OFL). Step 3A
// is the first UI text that uses them (see cream-screens.css).
import './styles/fonts.css';

import { render } from 'preact';
import { App } from './App.jsx';
// Restyle step 3A: the cream look on the home, room and menu screens.
// Imported after App so it wins equal-specificity battles with the
// older sheets (its selectors also carry their scope class).
import './styles/cream-screens.css';
import { waitForFont } from './ui/font-loader.js';
import { applySavedSettingsSync } from './settings.js';

// B2-12: apply saved CRT + font classes synchronously before the first
// render, so the class is present on the first frame (the async effect
// in App/useSettings landed after paint and flaked crt + font specs).
applySavedSettingsSync();

const root = document.getElementById('app');
if (!root) throw new Error('#app root element not found');

waitForFont().finally(() => {
  render(<App />, root);
});
